<template>
  <div class="container">
    <table></table>
    <div style="margin:10px;">
      <van-list
        v-model="loading"
        :finished="finished"
        :immediate-check="false"
        finished-text="没有更多啦"
        @load="load_more"
      >
      <div class="main" v-for="item in list" :key="item.id" @click="urlchange(item.id,item.type,item.link)">
        <div class="left">
          <p class="title">{{item.title}}</p>
          <div class="flex">
            <span class="name">{{item.org_name}}</span>
            <span style="margin:0 10px;white-space:nowrap;">{{item.createtime}}</span>
          </div>
        </div>
        <div class="right">
          <img :src="item.cover" alt="">
        </div>
      </div>
      </van-list>
    </div>
  </div>
</template>
<script>
export default {
  name:'onlinelearn',
  data() {
    return {
      list:[],
      list:[],
      loading:false,
      finished:false,
      page: 1,
    }
  },
  created(){
    this.$axios({
      method:'post',
      url:'/api/policy/list',
      data:this.qs.stringify({
        token:sessionStorage.getItem('wmtoken'),
        mod:2,
      })
    }).then(res => {
      console.log(res.data);
      if(res.data.code == 0){
        this.list = res.data.data.list;
        console.log(this.timeTrans(this.list[0].createtime));
        for(let i in res.data.data.list){
          this.list[i].createtime = this.timeTrans(res.data.data.list[i].createtime);
          this.$forceUpdate();
        }
      }
    })
  },
  methods:{
    urlchange(id,type,link){
      if(type == 1){
        this.$router.push({
          name:'policydetail',
          query:{
            id:id
          }
        })
      }else{
        window.location.href = link;
      }
    },
    load_more(){
      this.page += 1;
      var that = this;
      setTimeout(function(){
        that.$axios({
          method:'post',
          url:'/api/policy/list',
          data:that.qs.stringify({
            token:sessionStorage.getItem('wmtoken'),
            page:that.page,
            mod:2,
          })
        }).then(res => {
          console.log(res.data);
          if(res.data.code == 0){
            for(let i in res.data.data.list){
              res.data.data.list[i].createtime = that.timeTrans(res.data.data.list[i].createtime);
            }
            that.list = that.list.concat(res.data.data.list);
          }
          that.loading = false;
          if (res.data.data.list.length == 0) {  //数据全部加载完成
            that.finished = true;
          }else{
            that.finished = false;
          }
        })
      },500)
    }
  }
}
</script>
<style scoped>
.container{
  min-height:100vh;
  background:#f2f2f2;
}
.main{
  display: flex;
  justify-content: space-between;
  padding: 10px;
  background: white;
  border-bottom: 1px solid #eee;
}
.right{
  width: 35vw;
  height: 20vw;
}
.right img{
  width: 100%;
  height: 100%;
  border-radius: 5px;
  /* object-fit: cover; */
}
.title{
  width: 100%;
  display:-webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  font-weight: bold;
}
.left{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width:62%;
}
.flex{
  display: flex;
  color: grey;
  font-size: 12px;
  align-items: center;
  justify-content: space-between;
}
.name{
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap; 
}
</style>


// WEBPACK FOOTER //
// src/components/onlinelearn.vue